import { defineStore } from 'pinia';
import axios from 'axios';

/**
 * Reduce a given array of object to specific properties
 */

function selectProps(...props) {
  // eslint-disable-next-line func-names
  return function (obj) {
    const newObj = {};
    props.forEach((name) => {
      newObj[name] = obj[name];
    });
    return newObj;
  };
}

export const useAutocompleteStore = defineStore('autocomplete', {
  state: () => ({
    streets: [],
    cities: [],
  }),
  getters: {
    getStreets() {
      return this.streets;
    },
    getCities() {
      return this.cities;
    },
  },
  actions: {
    async getUniqueStreets(street) {
      const params = new URLSearchParams([
        ['street', street],
        ['collapse', 'street'],
      ]);
      const locationData = await axios.get(`${window.app.pnpform.api_base}location.json`, { params });
      const uniqueStreetData = locationData.data.map(selectProps('street'));

      this.$patch({
        streets: uniqueStreetData,
      });
    },
    async getUniqueCities(city) {
      const params = new URLSearchParams([
        ['city', city],
        ['collapse', 'city'],
      ]);
      const locationData = await axios.get(`${window.app.pnpform.api_base}location.json`, { params });
      const uniqueCityData = locationData.data.map(selectProps('city'));

      this.$patch({
        cities: uniqueCityData,
      });
    },
  },
});
